import { useRef } from 'react';

import { useToggleState } from '@portal/hooks';

export const usePopover = () => {
  const anchorRef = useRef(null);
  const [isOpen, toggleIsOpen] = useToggleState(false);
  return [isOpen, toggleIsOpen, anchorRef];
};
